module.exports = __webpack_public_path__ + "static/media/empty state image for form window.fa58e4a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/empty state image for form window.png
// module id = 2138
// module chunks = 17